import * as moment from 'moment-timezone'
import { Moment } from 'moment'
import { RangeValueRecordWithPreset } from '../../../types/range-value'
import { TimeRangePickerProps } from 'antd'
import dayjs from 'dayjs'

/**
 * Moment based time range options
 *
 * @deprecated - use with < AntD@6
 */
export const TIME_RANGE_OPTIONS: RangeValueRecordWithPreset<Moment> = {
    ['Today']: () => [moment(), moment(), 'TODAY'],
    ['Yesterday']: () => [moment().subtract(1, 'd'), moment().subtract(1, 'd'), 'YESTERDAY'],
    ['Last 7 Days']: () => [moment().subtract(8, 'd'), moment().subtract(1, 'd'), 'LAST_7_DAYS'],
    ['Last 30 Days']: () => [moment().subtract(31, 'd'), moment().subtract(1, 'd'), 'LAST_30_DAYS'],
    ['Last 45 Days']: () => [moment().subtract(46, 'd'), moment().subtract(1, 'd'), 'LAST_45_DAYS'],
    ['Last 90 Days']: () => [moment().subtract(91, 'd'), moment().subtract(1, 'd'), 'LAST_90_DAYS'],
    ['This Month']: () => [moment().startOf('month'), moment().endOf('month'), 'THIS_MONTH'],
    ['Last Month']: () => [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
        'LAST_MONTH',
    ],
    ['This Year']: () => [moment().startOf('year'), moment(), 'THIS_YEAR'],
    ['Last Year']: () => [
        moment().subtract(1, 'year').startOf('year'),
        moment().subtract(1, 'year').endOf('year'),
        'LAST_YEAR',
    ],
    ['All Time']: () => [null, null],
}

export type TimeRangePreset = NonNullable<TimeRangePickerProps['presets']>[number] & { key: TimeRangePresetKey }

export enum TimeRangePresetKey {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_45_DAYS = 'LAST_45_DAYS',
    LAST_90_DAYS = 'LAST_90_DAYS',
    THIS_MONTH = 'THIS_MONTH',
    LAST_MONTH = 'LAST_MONTH',
    THIS_YEAR = 'THIS_YEAR',
    LAST_YEAR = 'LAST_YEAR',
    ALL_TIME = 'ALL_TIME',
    CUSTOM = 'CUSTOM',
}

export const TR_PRESET_TODAY: TimeRangePreset = {
    label: 'Today',
    value: [dayjs(), dayjs()],
    key: TimeRangePresetKey.TODAY,
}
export const TR_PRESET_YESTERDAY: TimeRangePreset = {
    label: 'Yesterday',
    value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    key: TimeRangePresetKey.YESTERDAY,
}
export const TR_PRESET_LAST_7_DAYS: TimeRangePreset = {
    label: 'Last 7 Days',
    value: [dayjs().subtract(8, 'day'), dayjs().subtract(1, 'day')],
    key: TimeRangePresetKey.LAST_7_DAYS,
}
export const TR_PRESET_LAST_30_DAYS: TimeRangePreset = {
    label: 'Last 30 Days',
    value: [dayjs().subtract(31, 'day'), dayjs().subtract(1, 'day')],
    key: TimeRangePresetKey.LAST_30_DAYS,
}
export const TR_PRESET_LAST_45_DAYS: TimeRangePreset = {
    label: 'Last 45 Days',
    value: [dayjs().subtract(46, 'day'), dayjs().subtract(1, 'day')],
    key: TimeRangePresetKey.LAST_45_DAYS,
}
export const TR_PRESET_LAST_90_DAYS: TimeRangePreset = {
    label: 'Last 90 Days',
    value: [dayjs().subtract(91, 'day'), dayjs().subtract(1, 'day')],
    key: TimeRangePresetKey.LAST_90_DAYS,
}
export const TR_PRESET_THIS_MONTH: TimeRangePreset = {
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('month')],
    key: TimeRangePresetKey.THIS_MONTH,
}
export const TR_PRESET_LAST_MONTH: TimeRangePreset = {
    label: 'Last Month',
    value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    key: TimeRangePresetKey.LAST_MONTH,
}
export const TR_PRESET_THIS_YEAR: TimeRangePreset = {
    label: 'This Year',
    value: [dayjs().startOf('year'), dayjs().endOf('year')],
    key: TimeRangePresetKey.THIS_YEAR,
}
export const TR_PRESET_LAST_YEAR: TimeRangePreset = {
    label: 'Last Year',
    value: [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
    key: TimeRangePresetKey.LAST_YEAR,
}
export const TR_PRESET_ALL_TIME: TimeRangePreset = {
    label: 'All Time',
    value: [null, null],
    key: TimeRangePresetKey.ALL_TIME,
}

export const TIME_RANGE_PRESETS = [
    TR_PRESET_TODAY,
    TR_PRESET_YESTERDAY,
    TR_PRESET_LAST_7_DAYS,
    TR_PRESET_LAST_30_DAYS,
    TR_PRESET_LAST_45_DAYS,
    TR_PRESET_LAST_90_DAYS,
    TR_PRESET_THIS_MONTH,
    TR_PRESET_LAST_MONTH,
    TR_PRESET_THIS_YEAR,
    TR_PRESET_LAST_YEAR,
    TR_PRESET_ALL_TIME,
]

export const OVERVIEW_TIME_RANGE_PRESETS = [
    TR_PRESET_LAST_7_DAYS,
    TR_PRESET_LAST_30_DAYS,
    TR_PRESET_LAST_90_DAYS,
    TR_PRESET_THIS_MONTH,
    TR_PRESET_ALL_TIME,
]

export const JOURNEY_TIME_RANGE_PRESETS: TimeRangePreset[] = OVERVIEW_TIME_RANGE_PRESETS
